<template>
  <div class="header">
    <div class="left">
      <div class="logo" @click="goHome">
        <img src="@/assets/img/logo.png" />
        项目管理平台 <span>{{ name }}</span>
      </div>
    </div>
    <monthMBTable ref="monthMBTable" />
    <div
      class="rigth"
      v-if="$route.path.toLowerCase() != '/login' && userInfo.username"
    >
    <el-button @click="bhd()">
        工作饱和度查询
      </el-button>
      <el-button
        @click="kfKPI"
        v-if="['黄桥', '罗宇庆', '赖柏均'].indexOf(userInfo.name) > -1"
      >
        开发月度考核表
      </el-button>
      <el-button
        @click="kfzb"
        v-if="['黄桥', '罗宇庆', '赖柏均'].indexOf(userInfo.name) > -1"
      >
        开发周报
      </el-button>
      <el-button
        @click="kfyb"
        v-if="['黄桥', '罗宇庆', '赖柏均'].indexOf(userInfo.name) > -1"
      >
        开发月报
      </el-button>
      <el-button @click="erkai()">
        开发任务列表
      </el-button>
      <el-button @click="showTable()" v-if="!userInfo.kf||['黄桥', '赖柏均', '梁子锋'].indexOf(userInfo.name) > -1">
        每月目标
      </el-button>
      <el-button
        @click="handleCommand('dictionary')"
        v-if="userInfo.rootty && (!userInfo.kf||['黄桥', '赖柏均', '梁子锋'].indexOf(userInfo.name) > -1)"
      >
        字典管理
      </el-button>
      <el-button @click="handleCommand('tydy')" v-if="!userInfo.kf">
        通用调研
      </el-button>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{ userInfo.name }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="setpwd">修改密码</el-dropdown-item>
          <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <kfKPITable ref="kfKPITable" :tableData="tableData" :query="query" />
    </div>
    <veaDialog
      :title="'修改密码'"
      :show.sync="show"
      :before-close="closeDialogre"
      class="setpwd"
    >
      <el-form ref="form" :model="form" label-width="60px">
        <el-form-item label="原密码">
          <el-input v-model="form.oldpwd" show-password placeholder="请输入">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="form.pwd" show-password placeholder="请输入">
          </el-input>
        </el-form-item>
      </el-form>
    </veaDialog>
    <veaDialog
      :title="
        query.kftype == 1
          ? '开发周报'
          : query.kftype == 2
          ? '开发月度考核表'
          : '开发月报'
      "
      :show.sync="showkf"
      :before-close="closeDialoKF"
      :class="{ kfDialog: true, kfDialog2: query.kftype == 2 }"
      confirmButtonText="确定"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="开始结束日期" v-if="query.kftype == 1">
          <el-date-picker
            type="date"
            placeholder="日开始"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="query.bd"
            class="i150"
          ></el-date-picker>
          <span>-</span>

          <el-date-picker
            type="date"
            placeholder="日结束"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="query.ed"
            class="i150"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="月份" v-else-if="query.kftype == 0">
          <el-select clearable v-model="query.yymm" placeholder="请选择月份">
            <el-option
              v-for="item in yymmArr"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <template v-else>
          <el-form-item label="月份">
            <el-select clearable v-model="query.yymm" placeholder="请选择月份">
              <el-option
                v-for="item in yymmArr"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开发人员">
            <el-select clearable v-model="query.fzr" placeholder="请选择开发人员">
              <el-option
                v-for="item in fzrList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </veaDialog>
  </div>
</template>

<script>
import { parseTime } from '@/utils'
import monthMBTable from '@components/monthMBTable.vue'
import {
  EditUserPwd,
  Query_tpr_erkaiTotal,
  GetKFlist,
  GetKFRp
} from '@api/api.js'
import kfKPITable from '@components/kfKPITable.vue'
export default {
  components: {
    monthMBTable,
    kfKPITable
  },
  data() {
    return {
      userInfo: sessionStorage.userInfo
        ? JSON.parse(sessionStorage.userInfo) || {}
        : [],
      name: this.$route.query.name,
      form: {
        autoid: '',
        oldpwd: '',
        pwd: ''
      },
      show: false,
      showkf: false,
      title: '',
      query: {
        kftype: 0, // 0月报 1周报
        bd: parseTime(new Date(), '{y}-{m}-{d}'),
        ed: parseTime(new Date(), '{y}-{m}-{d}'),
        yymm: parseTime(new Date(), '{y}{m}'),
        fzr: ''
      },
      tableData: [],
      fzrList: []
    }
  },
  computed: {
    yymmArr() {
      let arr = [],
        lastMonth = new Date()
      lastMonth.setMonth(lastMonth.getMonth() + 2)
      for (let index = 0; index < 7; index++) {
        lastMonth.setMonth(lastMonth.getMonth() - 1)
        arr.push(parseTime(lastMonth, '{y}{m}'))
      }

      return arr
    }
  },
  created() {
    this._GetKFlist()
  },
  methods: {
    _GetKFlist() {
      GetKFlist().then(res => {
        this.fzrList = res.list.map(e => {
          return e.empname
        })
      })
    },
    closeDialoKF(a) {
      if (a == 'confirm') {
        // 确定
        if (this.query.kftype == 2) {
          GetKFRp(this.query)
            .then(res => {
              if (res.error == '0') {
                window.open(res.list[0].ssourl, '_blank')
              } else {
                this.$message.error(res.errorinfo)
              }
            })
            .finally(res => {
              this.showkf = false
            })
        } else {
          Query_tpr_erkaiTotal(this.query)
            .then(res => {
              if (res.error == '0') {
                this.tableData = res.list
                this.$refs.kfKPITable.show = true
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(res => {
              this.showkf = false
            })
        }
      } else {
        this.showkf = false
      }
    },
    kfKPI() {
      this.query.kftype = 2
      this.showkf = true
    },
    kfzb() {
      this.query.kftype = 1
      this.showkf = true
    },
    kfyb() {
      this.query.kftype = 0
      this.showkf = true
    },
    goHome() {
      // console.log(this.$route)
      if (
        this.$route.path.toLowerCase() != '/login' &&
        this.$route.path.toLowerCase() != '/main/projectCanten'
      ) {
        this.$router.push('/main/projectCanten')
      }
    },
    handleCommand(command) {
      // alter(command)
      if (command == 'loginout') {
        sessionStorage.setItem('userInfo', '')
        this.$router.push('/login')
      } else if (command == 'tydy') {
        let query = {
          autoid: 0,
          name: '通用调研项目'
        }
        let path = '/main/tydy'
        this.$router.push({ path: path, query: query })
      } else if (command == 'dictionary') {
        this.$router.push('/main/dictionary')
      } else if (command == 'setpwd') {
        this.show = true
      }
    },

    showTable() {
      this.$refs.monthMBTable.show = true
    },
    erkai() {
      let query = {
        autoid: 0,
        name: '开发任务列表'
      }
      let path = '/main/erkai'
      this.$router.push({ path: path, query: query })
    },
    bhd() {
      let path = '/main/bhd'
      this.$router.push({ path: path })
    },
    closeDialogre(a) {
      if (a == 'confirm') {
        // 保存
        this.form.autoid = this.userInfo.autoid
        EditUserPwd(this.form)
          .then(res => {
            if (res.error == '0') {
              this.$message.success('修改成功')
            } else {
              this.$message.error(res.msg)
            }
          })
          .finally(res => {
            this.form.oldpwd = ''
            this.form.pwd = ''
            this.show = false
          })
      } else {
        this.show = false
      }
    }
  },
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        //判断newVal有没有值监听路由变化
        this.name = newVal.name || ''
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.header {
  height: 60px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  .left {
    padding-left: 10px;
    .logo {
      font-size: 36px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #252525;
      cursor: pointer;
      img {
        height: 40px;
        vertical-align: middle;
      }
      span {
        font-size: 20px;
        color: #333;
      }
    }
  }
  .rigth {
    height: 100%;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button {
      margin-right: 10px;
    }
    .el-dropdown {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      font-size: 20px;
    }
  }
}
.setpwd {
  /deep/ .el-dialog {
    @include wh(300px, 250px);

    .el-dialog__body {
      padding: 10px;
      height: 100%;
    }
  }
}
.kfDialog {
  /deep/ .el-dialog {
    @include wh(500px, 170px);
    .el-dialog__body {
      padding: 10px;
      .el-form-item {
        margin-bottom: 0;
      }
      .el-select {
        width: 100%;
      }
      .i150 {
        width: calc(50% - 1em);
      }
    }
  }
}
.kfDialog2 {
  /deep/ .el-dialog {
    @include wh(500px, 220px);
    .el-form-item {
      margin-bottom: 10px !important;
    }
  }
}
</style>
